import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card-item-tile__content" }
const _hoisted_2 = { class: "card-item-tile__name-container" }
const _hoisted_3 = {
  key: 0,
  class: "card-item__monitoring label-s"
}
const _hoisted_4 = {
  key: 0,
  class: "card-item-tile__ellipsis label-mono-m"
}
const _hoisted_5 = { class: "card-item-tile__watch-lists" }
const _hoisted_6 = { class: "card-item-tile__watch-lists-wrap" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "n-grow" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NThumbnail = _resolveComponent("NThumbnail")!
  const _component_WatchListsGroup = _resolveComponent("WatchListsGroup")!
  const _component_NButton = _resolveComponent("NButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.classes),
    style: _normalizeStyle(_ctx.styles),
    onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('select')), ["stop"]))
  }, [
    (_ctx.showThumbnail)
      ? (_openBlock(), _createBlock(_component_NThumbnail, {
          key: 0,
          loading: _ctx.thumbnailLoading,
          modelValue: _ctx.thumbnail,
          corners: _ctx.corners
        }, null, 8, ["loading", "modelValue", "corners"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "card-item-tile__name heading-m",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click-on-name')))
        }, _toDisplayString(_ctx.name), 1),
        (_ctx.hasAnyMonitoringRecord)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('remote_monitoring.monitoring_letter')), 1))
          : _createCommentVNode("", true)
      ]),
      ((_ctx.item as CarCard).license_plate_number)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString((_ctx.item as CarCard).license_plate_number), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_WatchListsGroup, {
            items: _ctx.item.watch_lists,
            type: _ctx.displayType
          }, null, 8, ["items", "type"])
        ]),
        _hoisted_7,
        (_ctx.showRelatedConnections)
          ? (_openBlock(), _createBlock(_component_NButton, {
              key: 0,
              type: _ctx.selected ? 'text' : 'link',
              icon: "cards_related",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('action', _ctx.ItemsActionNames.ShowRelatedConnections, _ctx.item)), ["stop"]))
            }, null, 8, ["type"]))
          : _createCommentVNode("", true),
        (_ctx.showMatchedConnections)
          ? (_openBlock(), _createBlock(_component_NButton, {
              key: 1,
              type: _ctx.selected ? 'text' : 'link',
              icon: "cards_matched",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$emit('action', _ctx.ItemsActionNames.ShowMatchedConnections, _ctx.item)), ["stop"]))
            }, null, 8, ["type"]))
          : _createCommentVNode("", true),
        (_ctx.showInteractions)
          ? (_openBlock(), _createBlock(_component_NButton, {
              key: 2,
              type: _ctx.selected ? 'text' : 'link',
              icon: "relations",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.$emit('action', 'show-interactions', _ctx.item)), ["stop"]))
            }, null, 8, ["type"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 6))
}